import GlobalVariable from '@/global/global-variable'

// 添加电子围栏
const addFenceApi = GlobalVariable.BASE_PATH + "/rest/fence/in/add";

// 编辑电子围栏
const updateFenceApi = GlobalVariable.BASE_PATH + "/rest/fence/in/update";

// 删除电子围栏
const deleteFenceApi = GlobalVariable.BASE_PATH + "/rest/fence/in/delete";

// 查询电子围栏信息
const searchFenceApi = GlobalVariable.BASE_PATH + "/rest/fence/in/search";

export default {
    addFenceApi,
    updateFenceApi,
    deleteFenceApi,
    searchFenceApi,
}



// WEBPACK FOOTER //
// ./src/request/api-fence.js